import httpClient from '@/common/httpClient'
import { apolloClient } from '@/common/service/apolloClient'
import { relatedCmsMagazines, sortedProductsQuery } from '@/categories/queries'
import { CATEGORY_PRODUCTS_ENDPOINTS } from '@/categories/const'
import { getCMSMagazineSection } from './types/getCMSMagazineSection'

export const getSortedProductsList = (categoryIds: number, sortOrder: string) => {
  return apolloClient.query({
    query: sortedProductsQuery,
    variables: {
      categoryIds: categoryIds,
      sortOrder: sortOrder
    }
  })
}

export const fetchCategoryProductList = (categoryId: number) => {
  const api = CATEGORY_PRODUCTS_ENDPOINTS + categoryId.toString()
  return httpClient.get(api)
}

export const getRelatedCmsMagazines = (categoryId: string) => {
  return apolloClient.query<getCMSMagazineSection>({
    query: relatedCmsMagazines,
    variables: {
      id: categoryId
    }
  })
}
